// Website routes
export const BASE_ROUTE = "";
export const HOME_ROUTE = `${BASE_ROUTE}/home`;
export const ABOUT_ROUTE = `${BASE_ROUTE}/about`;
export const SCHOOL_RESOURCES_ROUTE = `${BASE_ROUTE}/resources/school`;
export const TEACHERS_RESOURCES_ROUTE = `${BASE_ROUTE}/resources/teachers`;
export const PARENTS_RESOURCES_ROUTE = `${BASE_ROUTE}/resources/parents`;
export const BLOG_DETAIL_ROUTE = `${BASE_ROUTE}/resources/blog/:slug`;
export const FEATURES_ROUTE = `${BASE_ROUTE}/features`;
export const PRICING_ROUTE = `${BASE_ROUTE}/pricing`;
export const SIGNUP_ROUTE = `${BASE_ROUTE}/signup`;
export const LOGIN_ROUTE = `${BASE_ROUTE}/login`;
export const REQUEST_PASSWORD_RESET_ROUTE = `${BASE_ROUTE}/request-password-reset`;
export const PASSWORD_RESET_ROUTE = `${BASE_ROUTE}/reset-password/:uid/:token`;
export const EMAIL_VERIFICATION_ROUTE = `${BASE_ROUTE}/verify-email/:uid/:token`;
export const PUBLIC_ADMISSION_FORM_ROUTE = "/admission/:token";

// Admin routes
export const ADMIN_ROUTE = "/admin";
export const ADMIN_DASHBOARD_ROUTE = `${ADMIN_ROUTE}/dashboard`;
export const ADMIN_SCHOOLS_ROUTE = `${ADMIN_ROUTE}/schools`;
export const ADMIN_STUDENTS_ROUTE = `${ADMIN_ROUTE}/students`;
export const ADMIN_STUDENTS_DETAILS_ROUTE = `${ADMIN_ROUTE}/students/details/:studentId`;
export const ADMIN_STAFF_DETAILS_ROUTE = `${ADMIN_ROUTE}/staff/details/:staffId`;
export const ADMIN_ROOMS_ROUTE = `${ADMIN_ROUTE}/rooms`;
export const ADMIN_STAFF_ROUTE = `${ADMIN_ROUTE}/staff`;
export const ADMIN_SCHOOL_EDIT_ROUTE = `${ADMIN_ROUTE}/school`;
export const ADMIN_STUDENT_ATTENDANCE_ROUTE = `${ADMIN_ROUTE}/student-attendance`;
export const ADMIN_STAFF_ATTENDANCE_ROUTE = `${ADMIN_ROUTE}/staff-attendance`;
export const ADMIN_QURAN_REPORT_ROUTE = `${ADMIN_ROUTE}/quran-report`;
export const ADMIN_ADD_SCHOOL_ROUTE = `${ADMIN_ROUTE}/school/add`;
export const ADMIN_ROOM_STUDENTS_ROUTE = `${ADMIN_ROUTE}/rooms/:classId/students`;
export const ADMIN_MESSAGES_ROUTE = `${ADMIN_ROUTE}/messages`;
export const ADMIN_CALENDAR_ROUTE = `${ADMIN_ROUTE}/calendar`;
export const ADMIN_ADMISSION_FORM_ROUTE = `${ADMIN_ROUTE}/admission-form`;
export const ADMIN_ADMISSION_FORM_OVERVIEW_ROUTE = `${ADMIN_ROUTE}/admission-overview`;
export const ADMIN_ADMISSION_CHILD_DETAILS_ROUTE = `${ADMIN_ROUTE}/admission-overview/:childId`;
export const ADMIN_DOCUMENTS_ROUTE = `${ADMIN_ROUTE}/documents`;

// Dynamic routes
export const DYNAMIC_ROUTES = {
  blogDetail: (slug) => `${BASE_ROUTE}/resources/blog/${slug}`,
};
